import { Suspense, lazy, useEffect, useState } from "react"

import {
  RecoilRoot,
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
} from "recoil"
import {
  sizeState,
  themeState,
  userObjState,
  pagesNprofileState,
  updatedPagesObjState,
  updatedProfileObjState,
} from "../recoil-atom"

import { authService, dbService } from "../fbase"
import { onAuthStateChanged, updateProfile } from "firebase/auth"
// import {
//   createUserWithEmailAndPassword,
//   signInWithEmailAndPassword,
//   GoogleAuthProvider,
//   GithubAuthProvider,
//   signInWithPopup,
// } from "firebase/auth"
import {
  collection,
  query,
  doc,
  setDoc,
  getDoc,
  addDoc,
  getDocs,
  onSnapshot,
} from "firebase/firestore"

import "./App.css"

import Init from "./Init"
import AppRouter from "./Router"
// import Footer from "./Footer"
// const AppRouter = lazy(() => import("./Router"))


function App() {
  const [init, setInit] = useState(false)
  const [theme, setTheme] = useRecoilState(themeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const { pagesObj, profileObj, shortName } = useRecoilValue(pagesNprofileState)
  const [updatedPagesObj, setUpdatedPagesObj] =
    useRecoilState(updatedPagesObjState)
  const [updatedProfileObj, setUpdatedProfileObj] = useRecoilState(
    updatedProfileObjState
  )

  useEffect(() => {
    onAuthStateChanged(authService, async (user) => {
      if (user) {
        const docRef = doc(dbService, "users", user.uid)
        const docSnap = await getDoc(docRef)
        const newUserObj = docSnap.data()

        window.localStorage.setItem("user", JSON.stringify(newUserObj))
        setUserObj({
          ...newUserObj,
          updateProfile: (args) => updateProfile(authService.currentUser, args),
        })
      }
      setUpdatedPagesObj({ ...pagesObj })
      setUpdatedProfileObj(profileObj)
      setInit(true)
    })
    // console.log("userObj", userObj)
    // console.log("pagesObj", pagesObj)
    // console.log("profileObj", profileObj)
    // console.log("updatedPagesObj", updatedPagesObj)
    // console.log("updatedProfileObj", updatedProfileObj)
  }, [])

  const refreshUser = async () => {
    const user = authService.currentUser

    const docRef = doc(dbService, "users", user.uid)
    const docSnap = await getDoc(docRef)
    const newUserObj = docSnap.data()

    window.localStorage.setItem("user", JSON.stringify(newUserObj))

    setUserObj({
      ...newUserObj,
      updateProfile: (args) => updateProfile(authService.currentUser, args),
    })
  }

  // Window Size
  const [size, setSize] = useRecoilState(sizeState)
  const onChangeSize = () => {
    const contentWidth =
      document.documentElement.clientWidth < 1140
        ? document.documentElement.clientWidth
        : 1140

    if (contentWidth === 1140) {
      setSize({
        appWidth: 1140,
        appHeight: document.documentElement.clientHeight,
        appPage: 2,
        pageWidth: 540,
        pageItem: 6,
      })
    } else if (contentWidth >= 780) {
      setSize({
        appWidth: contentWidth,
        appHeight: document.documentElement.clientHeight,
        appPage: 2,
        pageWidth: (contentWidth - 60) / 2,
        pageItem: 4,
      })
    } else if (contentWidth >= 540) {
      setSize({
        appWidth: contentWidth,
        appHeight: document.documentElement.clientHeight,
        appPage: 1,
        pageWidth: contentWidth,
        pageItem: 6,
      })
    } else if (contentWidth >= 360) {
      setSize({
        appWidth: contentWidth,
        appHeight: document.documentElement.clientHeight,
        appPage: 1,
        pageWidth: contentWidth,
        pageItem: 4,
      })
    }
  }

  // Swipe
  let initX, initY
  const [swipe, setSwipe] = useState(null)
  const onPointerMove = (event) => {
    const diffX = initX - event.clientX
    const diffY = initY - event.clientY
    if (Math.abs(diffX) > Math.abs(diffY)) {
      if (diffX > 100) {
        setSwipe("left")
      } else if (diffX < -100) {
        setSwipe("right")
      }
    }
  }
  const onSwipe = (event) => {
    initX = event.clientX
    initY = event.clientY
    window.addEventListener("pointerup", onPointerMove)
  }

  // Eventlistener for hardware
  useEffect(() => {
    onChangeSize()
    window.addEventListener("resize", onChangeSize)
    window.addEventListener("orientationchange", onChangeSize)
    window.addEventListener("pointerdown", onSwipe)
  }, [])

  return (
    <>
      <div className="App">
        {init ? <AppRouter refreshUser={refreshUser} /> : <Init />}
      </div>
      {/* <Suspense fallback={<Init />}>
        <AppRouter refreshUser={refreshUser} />
      </Suspense> */}

      <style jsx>{`
        .App {
          background-color: ${userObj && userObj.colors
            ? userObj.colors.b0
            : theme.b0};
        }
      `}</style>
    </>
  )
}

export default App
